import DateTime from "../Components/DateTime";
import PageTabs from "../Components/PageTabs";
import React, { useState, useEffect, useRef, useContext } from "react";
import 'react-quill/dist/quill.snow.css'
import MainButton from "../Props/MainButton";
import ToolTipMaster from "../Props/ToolTipMaster";
import AlertBox from "../Props/AlertBox";
import MyContext from "../MyContext";
import Loader from "../Props/Loader";
import { useNavigate } from 'react-router-dom';
import ImageUploadWithPreview from "../Components/ImagePreview";
import LensTypeMasterApi from "../../API/APIServices/LensTypeMaster";

function LensTypeMaster(props) {

    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const { OpenAlertBox, alertBox, OpenAlertBoxEdit, alertBoxEdit } = useContext(MyContext);
    const [ItemImage, setItemImage] = useState([]);
    const [imageIds, setImageIds] = useState([]);
    const [ItemImages, setItemImages] = useState([]);

    useState(() => {
        document.title = 'Lens Type Master';
    }, []);

    const [errorMessages, setErrorMessages] = useState({
        title: '',
    });

    const [inputValues, setInputValues] = useState({
        title: '',
        ef1: '',
        description: '',
        ef2: '',
        isActive: 'true'
    });

    const handleInputChangeActive = (e) => {
        const { name, type, checked } = e.target;
        const newValue = type === 'checkbox' ? checked : e.target.value;

        setInputValues((prevInputValues) => ({
            ...prevInputValues,
            [name]: type === 'checkbox' ? !prevInputValues[name] : newValue,
        }));


        setErrorMessages((prevErrors) => ({ ...prevErrors, [name]: '' }));
        console.log(inputValues);
    };

    const input1Ref = useRef(null);
    const input2Ref = useRef(null);
    const input3Ref = useRef(null);


    const handleKeyPress = (event, nextInputRef) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            nextInputRef.current.focus();
        }
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        console.log(`Changing ${name} to ${value}`);

        setInputValues((prevValues) => ({
            ...prevValues,
            [name]: value,
        }));
        // setInputValues((prevInputValues) => ({
        //     ...prevInputValues,
        //     [name]: value,
        //     printName: name === 'name' ? value : prevInputValues.printName,
        // }));
        setErrorMessages((prevErrors) => ({ ...prevErrors, [name]: '' }));
    };

    const toFriendlyName = (fieldName) => {
        return fieldName
            .replace(/([A-Z])/g, ' $1') // Add space before capital letters
            .replace(/^./, (str) => str.toUpperCase()); // Capitalize the first letter
    };

    const validateInput = (fieldName) => {
        console.log(fieldName);
        const fieldValue = inputValues[fieldName];

        if (!fieldValue || (typeof fieldValue === 'string' && fieldValue.trim() === '')) {
            setErrorMessages((prevErrors) => ({
                ...prevErrors,
                [fieldName]: `${toFriendlyName(fieldName)} field is required`,
            }));
            return false;
        }

        return true;
    };
    const fieldNames = ['title','ef1', 'description','ef2'];

    const SaveBtn = async () => {
        
        let allValid = true;
        fieldNames.forEach((fieldName) => {
            const isValid = validateInput(fieldName);
            if (!isValid) {
                allValid = false;
            }
        });
        if (allValid) {
            setLoading(true);

            let imageUploadSuccess = true;
        // if (ItemImages && ItemImages.length > 0) {
        //     for (let imageFile of ItemImages) {
        //         const uploadResult = await LensTypeMasterApi.UpdateLensTypeImage(imageFile);
        //         if (!uploadResult) {
        //             imageUploadSuccess = false;
        //             alert("Error while uploading image");
        //             break;
        //         }
        //     }
        // }

        if (imageUploadSuccess) {
            if (Boolean(props.modelOpen) === true) {
                
                const isSuccess = await LensTypeMasterApi.updateLensTypeMaster(inputValues);
                if (isSuccess) {
                    OpenAlertBoxEdit();
                    setLoading(false);
                    props.fetchData()
                    props.setSliderCallBack(false);
                    if (ItemImages.length == 1) {
                        await LensTypeMasterApi.UpdateLensTypeImage(ItemImages,inputValues.id);
                    }
                } else {
                    alert("error while updating");
                }
            }
            else {
                setLoading(true);
                const isSuccess = await LensTypeMasterApi.insertLensTypeMaster(inputValues);
                if (isSuccess) {
                    setLoading(false);
                    OpenAlertBox();
                    if (ItemImages.length > 0) {
                        await LensTypeMasterApi.UpdateLensTypeImage(ItemImages, isSuccess.result.id);
                    }
                } else {
                    alert("Error inserting data");
                }
            }
        }
            setInputValues({
                title: "",
                ef1: "",
                description: "",
                ef2: "",
                isActive: true,
            });
        }
    }

    useEffect(() => {
        
        const fetchData = async () => {
            try {
                if (props.editData) {
                    try {
                        const data = await props.editData; // Assuming props.editData is a Promise
                        console.log(data);
                        setInputValues(data);
                        if (data.image) {
                            setImageIds([data.image]);  // Store image IDs
                        }
                    } catch (error) {
                        console.error("Error fetching data:", error);
                    }
                }
            } catch (error) {
                console.log(error);
            }
        };
        fetchData();
    }, [props.editData]);

    const ItemImageUpload = (e, indx) => {
        const newItemImage = [...ItemImage];
        // If indx is within bounds of the array, update it; otherwise, push it to the end
        if (indx >= 0 && indx < newItemImage.length) {
          newItemImage[indx] = e;
        } else {
          newItemImage.push(e);
        }
        setItemImages(newItemImage);
      };
    

    return (
        <div>
            <PageTabs locationTab={"/LensTypeMaster"} modelOpen={props.modelOpen} setSliderCallBack={props.setSliderCallBack} />
            <div className="panel-heading">
                <div className="panel-head-title">
                    <h2 className="panel-title">Lens Type Master</h2>
                </div >
                {/* *******************Top Buttons****************** */}
                <MainButton PageName="Masters" SaveButton={SaveBtn}  modelOpen={props.modelOpen} setSliderCallBack={props.setSliderCallBack} />
            </div>
            <div>
                <DateTime />
            </div>
            <div className="content_box">
                <div className="company-info-top-im">
                    <div className="tab-head">
                        <div id="tabs">
                            <div className="tab-content-box">
                                <div className="tab-content-1">
                                    <div className="company-info-top-left" >
                                        <div className="company_info-text-im td-1">General Details
                                            <div className="input-box-checkbox1 ">
                                                <div className=" td-2">
                                                    <div className="ToggleSwitchActive td-3">
                                                        <label className="cl-switch">
                                                            <input type="checkbox" onChange={handleInputChangeActive} name="isActive" checked={inputValues.isActive} value={inputValues.isActive} />
                                                            <span></span>
                                                        </label>
                                                    </div>
                                                    <ToolTipMaster isActiveInactive={true} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="">
                                            <div className="input-box-Im ">
                                                <div className="input-box-m2">
                                                    <input className="modify_im_input mode_category"
                                                        onChange={handleInputChange}
                                                        onKeyPress={(e) => handleKeyPress(e, input2Ref)}
                                                        ref={input1Ref}
                                                        value={inputValues.title}
                                                        name="title"
                                                        type="text" required />
                                                    <label className="modify_p_text2">Lens Title  <span className="StarClr">*
                                                        {errorMessages.title && <label className="errorMessage">{errorMessages.title}</label>}
                                                    </span></label>
                                                </div>
                                            </div>
                                            <div className="input-box-Im ">
                                                <div className="input-box-m2">
                                                    <input className="modify_im_input mode_category"
                                                        onChange={handleInputChange}
                                                        onKeyPress={(e) => handleKeyPress(e, input2Ref)}
                                                        ref={input1Ref}
                                                        value={inputValues.ef1}
                                                        name="ef1"
                                                        type="number" required />
                                                    <label className="modify_p_text2">Lens Type Number  <span className="StarClr">*
                                                        {/* {errorMessages.title && <label className="errorMessage">{errorMessages.title}</label>} */}
                                                    </span></label>
                                                </div>
                                            </div>
                                            <div className="input-box-Im ">
                                                <div className="input-box-m2">
                                                    <input className="modify_im_input mode_category"
                                                        onChange={handleInputChange}
                                                        onKeyPress={(e) => handleKeyPress(e, input1Ref)}
                                                        ref={input2Ref}
                                                        value={inputValues.description}
                                                        name="description"
                                                        type="text" required />
                                                    <label className="modify_p_text2">Description
                                                        {/* <span className="StarClr">*
                                                            {errorMessages.name && <label className="errorMessage">{errorMessages.name}</label>}
                                                        </span> */}
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="input-box-Im ">
                                                <div className="input-box-m2">
                                                    <input className="modify_im_input mode_category"
                                                        onChange={handleInputChange}
                                                        onKeyPress={(e) => handleKeyPress(e, input1Ref)}
                                                        ref={input2Ref}
                                                        value={inputValues.ef2}
                                                        name="ef2"
                                                        type="number" required />
                                                    <label className="modify_p_text2">Priority
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="radio-buttons-container1 m2 overstack" style={{marginTop: "35px"}}>
                                                <ImageUploadWithPreview
                                                   setItemImage={setItemImages}
                                                   ItemImage={ItemImages}
                                                   ItemImageUpload={(event) => ItemImageUpload(event, 0)}
                                                   imageIds={imageIds}
                                                   imgIndex={0}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="buttom-box">
                        <div className="button-btn-1">
                            <button className="btn-1">Save</button>
                        </div>
                        <div className="button-btn-2">
                            <button className="btn-2">Reset</button>
                        </div>
                        <div className="button-btn-3">
                            <button className="btn-3"><i className="fa-solid fa-gear "></i></button>
                        </div>
                    </div>
                </div>
            </div>
            {alertBox && (
                <AlertBox
                    HeadingTop="Saved"
                    Heading="Your Lens Type Master is Saved"
                    onYesClick={OpenAlertBox}
                    singleButton={true}
                    OpenAlertBox={OpenAlertBox}
                />
            )}

            {alertBoxEdit && (
                <AlertBox
                    HeadingTop="Updated"
                    Heading="Your Lens Type Master is Updated"
                    onYesClick={OpenAlertBoxEdit}
                    singleButton={true}
                    OpenAlertBox={OpenAlertBoxEdit}
                />
            )}
            {loading && <Loader />}
        </div >
    );
}


export default LensTypeMaster;
